<template>
  <div>
    <v-progress-circular v-if="status == 'EXECUTANDO'" indeterminate color="black" size="20" width="1" class="ml-3" />
    <span v-else-if="status == 'SUCESSO' || status == 'OK'" class="size-status success--text">
      <v-icon small color="success" class="icon-status pb-1">mdi-check-bold</v-icon>
      Sucesso
    </span>
    <span v-else-if="status == 'FALHA'" class="error--text size-status">
      <v-icon small color="error" class="icon-status pb-1">mdi-alert</v-icon>
      Falha
    </span>
    <span v-else-if="status == 'ERRO_CRITICO'" class="error--text size-status">
      <v-icon small color="error" class="icon-status pb-1">mdi-alert-octagon</v-icon>
      Erro Crítico
    </span>
    <span v-else-if="status == 'ERRO_NAO_CRITICO'" class="size-status" style="color: #ffb000">
      <v-icon small color="#FFB000" class="icon-status pb-1">mdi-alert-rhombus</v-icon>
      Erro Não Crítico
    </span>
    <span v-else-if="status == 'EXCECAO'" class="size-status success--text">
      <v-icon small color="success" class="icon-status pb-1">mdi-alert-rhombus</v-icon>
      Exceção
    </span>
    <span v-else-if="status == 'ANALISE_FUTURA'" class="size-status warning--text">
      <v-icon small color="warning" class="icon-status pb-1">mdi-alert-rhombus</v-icon>
      Análise Futura
    </span>
    <span v-else-if="status == 'AGUARDANDO'" class="info--text size-status">
      <v-icon small color="info" class="icon-status pb-1">mdi-clock-time-four-outline</v-icon>
      Aguardando
    </span>
    <span v-else-if="status == 'EM-ANALISE'" class="accent--text size-status">
      <v-icon small color="accent" class="icon-status pb-1">mdi-timer-sand</v-icon>
      Em Análise
    </span>
    <span v-else-if="status == 'EXPIRADO'" class="size-status" style="color: gray">
      <v-icon small color="gray" class="icon-status pb-1">mdi-timer-off-outline</v-icon>
      Expirado
    </span>
    <span v-else-if="status == 'DUPLICADO'" class="size-status" style="color: #00cde2">
      <v-icon small color="#00cde2" class="icon-status pb-1">mdi-content-copy</v-icon>
      Duplicado
    </span>
    <span v-else-if="status == 'JUSTIFICADO'" class="info--text size-status">
      <v-icon small color="info" class="icon-status pb-1">mdi-circle-edit-outline</v-icon>
      Justificado
    </span>
    <span v-else class="size-status" style="color: gray">
      {{ treatedStatus }}
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      status: {
        type: String,
        required: true
      }
    },
    computed: {
      treatedStatus() {
        return this.status.charAt(0).toUpperCase() + this.status.slice(1).toLowerCase();
      }
    }
  };
</script>

<style>
  .size-status {
    font-size: 0.95rem !important;
    font-weight: normal !important;
  }
  .size-status .v-icon {
    font-size: 0.9rem !important;
  }
  .icon-status {
    margin-right: 1.7px !important;
  }
</style>
